var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCameraWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 50,
    viewBox: "0 0 54 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49 12.0007H41.6033L37.3333 7.33398H23.3333V12.0007H35.28L39.55 16.6673H49V44.6673H11.6667V23.6673H7V44.6673C7 47.234 9.1 49.334 11.6667 49.334H49C51.5667 49.334 53.6667 47.234 53.6667 44.6673V16.6673C53.6667 14.1007 51.5667 12.0007 49 12.0007ZM18.6667 30.6673C18.6667 37.1073 23.8933 42.334 30.3333 42.334C36.7733 42.334 42 37.1073 42 30.6673C42 24.2273 36.7733 19.0007 30.3333 19.0007C23.8933 19.0007 18.6667 24.2273 18.6667 30.6673ZM30.3333 23.6673C34.1833 23.6673 37.3333 26.8173 37.3333 30.6673C37.3333 34.5173 34.1833 37.6673 30.3333 37.6673C26.4833 37.6673 23.3333 34.5173 23.3333 30.6673C23.3333 26.8173 26.4833 23.6673 30.3333 23.6673ZM11.6667 12.0007H18.6667V7.33398H11.6667V0.333984H7V7.33398H0V12.0007H7V19.0007H11.6667V12.0007Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraWhite);
export default __webpack_public_path__ + "static/media/camera-white.d25e210973d166d28656072c32a7e092.svg";
export { ForwardRef as ReactComponent };